import { FC, ReactNode } from "react";
import { styles } from "./styles";

interface CenteredCardProps {
  title: string;
  children?: ReactNode;
}

export const CenteredCard: FC<CenteredCardProps> = ({ title, children }) => {
  return (
    <div style={styles.card}>
      <h2 style={styles.title}>{title}</h2>
      <div>{children}</div>
    </div>
  );
};
